import { render, staticRenderFns } from "./MobileCarousel.vue?vue&type=template&id=b8ac3434&scoped=true"
import script from "./MobileCarousel.vue?vue&type=script&lang=js"
export * from "./MobileCarousel.vue?vue&type=script&lang=js"
import style0 from "./MobileCarousel.vue?vue&type=style&index=0&id=b8ac3434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac3434",
  null
  
)

export default component.exports